import type {ReactElement, ReactNode} from 'react';
import React, {useRef} from 'react';
import {TimelineRefsContext} from './hooks/useTimelineRefs';
import type {TimelineRefsContextValue} from './hooks/useTimelineRefs';

interface TimelineRefsProviderProps {
  children: ReactNode;
}

export function TimelineRefsProvider({children}: TimelineRefsProviderProps): ReactElement {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const seekIndicatorRef = useRef<HTMLDivElement>(null);
  const hoverLineRef = useRef<HTMLDivElement>(null);

  const value: TimelineRefsContextValue = {
    scrollContainerRef,
    seekIndicatorRef,
    hoverLineRef,
  };

  return <TimelineRefsContext.Provider value={value}>{children}</TimelineRefsContext.Provider>;
}
